import React, { ReactNode, useMemo, CSSProperties, } from 'react';
import { Tabs } from 'antd';
import { TabsProps } from 'antd/lib/tabs';

export type { TabsProps };

export interface TabItemType {
  /** 对应 activeKey */
  key: string;
  /** 选项卡头显示文字 */
  label: ReactNode;
  /** 自定义关闭图标，在 type="editable-card"时有效 */
  closeIcon?: ReactNode;
  /** 是否禁用 */
  disabled?: boolean;
  /** 被隐藏时是否渲染 DOM 结构 */
  forceRender?: boolean;
  /** 选项卡头显示内容 */
  children?: ReactNode;
  /** 是否可以关闭 在 type="editable-card"时有效 */
  closable?: boolean;
  /** @deprecated tab属性已被label替代，请使用label，后续版本将移除tab */
  tab?: ReactNode;
  /** @deprecated tabKey属性已被key替代，请使用key，后续版本将移除key */
  tabKey?: string;
}

const ProTabs: React.FC<TabsProps> = (props) => {
  return <Tabs {...props} />;
};

export default ProTabs;
